import { createSelector } from '@ngrx/store';
import { State } from '../../store/index';
import { GlobalState } from '../global.model';

export const globalStateSelector = (state: State): GlobalState => state.global;

export const organisationSelector = createSelector(globalStateSelector, (state) => state.organisation);

export const organisationTagSelector = createSelector(globalStateSelector, (state) => state.organisation?.tag);

export const organisationNameSelector = createSelector(globalStateSelector, (state) => state?.organisation?.name);

export const mainNavigationItemsSelector = createSelector(globalStateSelector, (state) => state?.navigation?.primary);

export const secondaryNavigationItemsSelector = createSelector(globalStateSelector, (state) => state?.navigation?.secondary);

export const allNavigationItemsSelector = createSelector(globalStateSelector, (state) => state?.navigation?.primary?.concat(state?.navigation?.secondary));

export const mobileLeftNavBarItemsSelector = createSelector(globalStateSelector, (state) => state?.navigation?.mobileLeftNavBar);

export const mobileRightNavBarItemsSelector = createSelector(globalStateSelector, (state) => state?.navigation?.mobileRightNavBar);

export const languageSelector = createSelector(globalStateSelector, (state) => state.language);

export const organisationsSelector = createSelector(globalStateSelector, (state) => state.organisations);

export const availableLanguagesSelector = createSelector(globalStateSelector, (state) => state?.organisation?.lang?.available || []);

export const organisationConfigurationSelector = createSelector(globalStateSelector, (state) => state?.organisation?.configuration);

export const organisationModulesSelector = createSelector(globalStateSelector, (state) => state?.organisation?.configuration?.modules);

export const organisationFeaturesConfigurationSelector = createSelector(globalStateSelector, (state) => state?.organisation?.configuration?.features);

export const servicesSelector = createSelector(globalStateSelector, (state) => state?.services);

export const serviceCategoriesSelector = createSelector(globalStateSelector, (state) => state?.serviceCategories);

export const serviceStatusesSelector = createSelector(globalStateSelector, (state) => state?.serviceStatuses);

export const collectionsSelector = createSelector(globalStateSelector, (state) => state?.collections);

export const areasSelector = createSelector(globalStateSelector, (state) => state?.areas);

export const profileOptionsSelector = createSelector(globalStateSelector, (state) => state?.organisation?.configuration?.profileOptions);

export const pgRequetesFeatureSelector = createSelector(globalStateSelector, (state) => state?.organisation?.configuration?.features?.requests?.pgRequetesIframe);

export const dashboardUrlSelector = createSelector(globalStateSelector, (state) => state?.organisation?.configuration?.dashboardUrl);

export const organisationColourSelector = createSelector(globalStateSelector, (state) => state?.organisation?.colour);

export const accessSelector = createSelector(globalStateSelector, (state) => state?.access);
